import { TopicError } from './topicClient.ts';

export type TopicDraft = { text: string; startKey: string; sessionId?: string; startCatalogHash?: string;
  pending?: { text: string; mode: 'dialogue' | 'practice'; key: string };
  answerText?: string; answerKey?: string; answerTurnId?: string;
  answerPending?: { text: string; turnId: string; key: string } };
type Port = Pick<Storage, 'getItem' | 'setItem'>;
export function readTopicDraft(storage: Port, key: string): TopicDraft | null {
  try {
    const raw = storage.getItem(key); if (raw === null) return null;
    const value = JSON.parse(raw);
    if (!value || typeof value.text !== 'string' || typeof value.startKey !== 'string'
      || (value.startCatalogHash !== undefined && (typeof value.startCatalogHash !== 'string' || !/^[a-f0-9]{64}$/.test(value.startCatalogHash)))
      || (value.sessionId !== undefined && typeof value.sessionId !== 'string')
      || ((value.pending || value.answerPending) && !value.sessionId)
      || (value.pending && (typeof value.pending.text !== 'string' || typeof value.pending.key !== 'string' || !['dialogue', 'practice'].includes(value.pending.mode)))
      || (value.answerPending && (typeof value.answerPending.text !== 'string' || typeof value.answerPending.key !== 'string' || typeof value.answerPending.turnId !== 'string'))) throw new Error('invalid draft');
    return value;
  } catch { throw new TopicError('local_draft_unconfirmed'); }
}
export function persistTopicDraft(storage: Port, key: string, draft: TopicDraft) {
  try {
    const raw = JSON.stringify(draft); storage.setItem(key, raw);
    if (storage.getItem(key) !== raw) throw new Error('readback');
  } catch { throw new TopicError('local_draft_unconfirmed'); }
}
